/// <reference types="google.maps" />

import {Inject, Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from 'rxjs';
import {DOCUMENT} from "@angular/common";

@Injectable()
export class MapService {
    // old key "AIzaSyCt-0LtpxUuh_Cduy9Z09icJN53mXguJKE"
    // private apiKey: string = "AIzaSyDmRq2sbL5RiFSZSDWx1Ah_w6WxAynECpQ";
  private apiKey: string = "AIzaSyCaWTG1YPIdxnuR4YPUXY4FbJUzsd570t4";


  private initialized: boolean = false;
    private apiLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    private nextAddressPrediction = null;

    constructor(
        @Inject(DOCUMENT) private document,
        // private readonly httpClient: HttpClient,
    ) {
        // nothing
    }

    public init(): Observable<boolean> {
        if (!this.initialized) {
            this.initialized = true;
            this.loadGoogleMaps('https://maps.googleapis.com/maps/api/js?libraries=places,maps,marker&key=' + this.apiKey + '&callback=Function.prototype', 'google-map', () => {
              this.apiLoaded.next(true);
            });
        }
        return this.apiLoaded;
    }

    public getAddressPredictions(query: string, timeout: number = 1): Promise<google.maps.places.QueryAutocompletePrediction[]> {
        if (query && query.length > 4) {
            return new Promise((resolve, reject) => {
                if (this.nextAddressPrediction) {
                    clearTimeout(this.nextAddressPrediction);
                    this.nextAddressPrediction = null;
                }
                this.nextAddressPrediction = setTimeout(() => {
                    this.nextAddressPrediction = null;
                    let autocompleteSrv = new google.maps.places.AutocompleteService();
                    autocompleteSrv.getQueryPredictions({
                        input: query,
                    }, function (predictions, status) {
                        if (status == google.maps.places.PlacesServiceStatus.OK) {
                            resolve(predictions);
                        } else {
                            reject(status);
                        }
                    });
                }, timeout);
            });
        } else {
            return Promise.resolve([]);
        }
    }

    public getGeocodeAddress(query: string): Promise<google.maps.GeocoderResult[]> {
      console.log("getGeocodeAddress...");
        if (query && query.length > 4) {
            let geocoder = new google.maps.Geocoder();
            return new Promise((resolve, reject) => {
                geocoder.geocode({
                    address: query
                }, function (results, status) {
                  console.log("geocoder status: " + status);
                    if (status == google.maps.GeocoderStatus.OK) {
                        resolve(results);
                    } else {
                        reject(status);
                    }
                });
            });
        } else {
            return Promise.resolve([]);
        }
    }

    private loadGoogleMaps(url: string, id: string, callback): void {
        if (!this.document.getElementById(id)) {
            const script = this.document.createElement('script');
            script.type = 'text/javascript';
            script.src = url;
            script.id = id;
            if (callback) {
                script.addEventListener(
                    'load',
                    (e) => {
                        callback(null, e);
                    },
                    false
                );
            }
            this.document.head.appendChild(script);
        }
    }
}
